import React, { useEffect, useState } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import axios from "axios";
import { withRouter } from 'react-router-dom';
import { SingleDatePicker } from "react-dates";
import moment from "moment-timezone";

// O job de processamento roda diariamente, em horário fixo (23h30), sem possibilidade de
// configuração dinâmica. Por isso, para um item ficar disponível a partir da data escolhida
// pela equipe, o dtAgendamento enviado à API precisa ser o dia anterior, neste horário de corte.
const HORA_CORTE_JOB = "23:00";

const dataDisponibilidadeParaDtAgendamento = (dataDisponibilidade) => {
    return moment(dataDisponibilidade.format('YYYY-MM-DD'), 'YYYY-MM-DD')
        .subtract(1, 'day')
        .format('YYYY-MM-DD') + ` ${HORA_CORTE_JOB}`;
};

const dtAgendamentoParaDataDisponibilidade = (dtAgendamento) => {
    return moment(dtAgendamento).tz('America/Sao_Paulo').add(1, 'day');
};

const CileBetalabsFilaDetails = (props) => {

    const itemEdicao = props.location.state || null;

    const [tiposItem, setTiposItem] = useState([]);
    const [tipoItem, setTipoItem] = useState(itemEdicao ? itemEdicao.tipoItem : "");
    const [idItemExterno, setIdItemExterno] = useState(itemEdicao ? itemEdicao.idItemExterno : "");
    const [tipoExecucao, setTipoExecucao] = useState(itemEdicao ? itemEdicao.tipoExecucao : 1);
    const ordenacaoInicial = itemEdicao && itemEdicao.payload && itemEdicao.payload.dadosBanner
        ? itemEdicao.payload.dadosBanner.ordenacao_banner_destaque_9_103
        : "";
    const [ordenacao, setOrdenacao] = useState(ordenacaoInicial || "");
    const [data, setData] = useState(itemEdicao ? dtAgendamentoParaDataDisponibilidade(itemEdicao.dtAgendamento) : null);
    const [focused, setFocused] = useState(false);

    const imagemInicial = (itemEdicao && itemEdicao.payload && itemEdicao.payload.dadosPlano && itemEdicao.payload.dadosPlano.imageUrl)
        || (itemEdicao && itemEdicao.payload && itemEdicao.payload.dadosProduto && itemEdicao.payload.dadosProduto.arrayImgs && itemEdicao.payload.dadosProduto.arrayImgs[0] && itemEdicao.payload.dadosProduto.arrayImgs[0].imageUrl)
        || "";

    const [image, setImage] = useState();
    const [imageName, setImageName] = useState(null);
    const [temArquivo, setTemArquivo] = useState(false);
    const [loadingSalvarImg, setLoadingSalvarImg] = useState(false);
    const [arquivoSalvo, setArquivoSalvo] = useState(!!imagemInicial);
    const [imageUrl, setImageUrl] = useState(imagemInicial);
    const [mensagemSalvar, setMensagemSalvar] = useState(false);

    const [salvando, setSalvando] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/admin-betalabs/fila-cile/tipos-item`)
            .then(response => {
                setTiposItem(response.data.dados);
            })
            .catch(error => {
                console.log("ERROR: ", error);
            });
    }, []);

    const onSelectFileImage = (e) => {
        setImage(e.target.files[0]);
        setTemArquivo(true);
        setArquivoSalvo(false);
    };

    const salvarImg = async () => {
        const config = new Configurations();
        const bodyFormData = new FormData();
        bodyFormData.append('imagem', image);
        bodyFormData.append('nomeImagem', imageName);

        setLoadingSalvarImg(true);

        await axios.post(config.apiBasePath + `/cile/fila-betalabs/imagem/upload`, bodyFormData)
            .then(response => {
                setImageUrl(response.data.image);
                setArquivoSalvo(true);
            })
            .catch(err => {
                console.log("ERROR:", err);
            })
            .finally(() => {
                setLoadingSalvarImg(false);
            });
    };

    const podeSalvar = () => {
        if (!tipoItem || !idItemExterno || !data) return false;
        if (temArquivo && !arquivoSalvo) return false;
        return true;
    };

    const salvar = () => {
        if (temArquivo && !arquivoSalvo) {
            setMensagemSalvar(true);
            return;
        }

        const config = new Configurations();
        const dtAgendamento = moment(dataDisponibilidadeParaDtAgendamento(data), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');

        const body = {
            tipoItem: Number(tipoItem),
            idItemExterno: Number(idItemExterno),
            tipoExecucao: Number(tipoExecucao),
            dtAgendamento,
            ordenacao: ordenacao || undefined,
            imageUrl: imageUrl || undefined
        };

        setSalvando(true);
        setErro(null);

        const chamada = itemEdicao
            ? axios.put(config.apiBasePath + `/admin-betalabs/fila-cile/${itemEdicao.id}/atualizar`, body)
            : axios.post(config.apiBasePath + `/admin-betalabs/fila-cile/agendar`, body);

        chamada
            .then(() => {
                setModalSuccess(true);
            })
            .catch(error => {
                console.log("ERROR: ", error);
                const mensagemErro = error.response && error.response.data && error.response.data.mensagem;
                setErro(mensagemErro || "Erro inesperado ao salvar o agendamento.");
            })
            .finally(() => {
                setSalvando(false);
            });
    };

    const toggleModal = () => {
        setModalSuccess(!modalSuccess);
        window.history.go(-1);
    };

    const tipoItemNum = Number(tipoItem);

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">{itemEdicao ? "CILE - Editar agendamento Betalabs" : "CILE - Novo agendamento Betalabs"}</h2>
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters px-3 py-3">
                    <div className="col-12 col-lg-6 px-2">
                        <label className="pl-2"><strong>Tipo de item:</strong></label>
                        <select
                            className="form-control"
                            value={tipoItem}
                            onChange={(e) => setTipoItem(e.target.value)}
                            disabled={!!itemEdicao}
                        >
                            <option value="">Selecione...</option>
                            {tiposItem.map((tipo) => (
                                <option key={tipo.tipoItem} value={tipo.tipoItem}>{tipo.nome}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-12 col-lg-6 px-2 mt-3 mt-lg-0">
                        <label className="pl-2"><strong>Disponível a partir de:</strong></label>
                        <SingleDatePicker
                            date={data}
                            onDateChange={setData}
                            focused={focused}
                            onFocusChange={({ focused }) => setFocused(focused)}
                            id="dtAgendamento"
                            numberOfMonths={1}
                            small={true}
                            isOutsideRange={(day) => day.isBefore(moment().add(1, 'day'), 'day')}
                            placeholder=""
                            block={true}
                        />
                        <small className="pl-2 text-muted">O item ficará disponível a partir da meia-noite do dia selecionado (processamento diário, em horário fixo, no dia anterior).</small>
                    </div>

                    <div className="col-12 col-lg-6 px-2 mt-3">
                        <label className="pl-2"><strong>ID do item no Betalabs:</strong></label>
                        <input
                            type="number"
                            className="form-control"
                            value={idItemExterno}
                            onChange={(e) => setIdItemExterno(e.target.value)}
                        />
                    </div>

                    <div className="col-12 col-lg-6 px-2 mt-3">
                        <label className="pl-2"><strong>Ação:</strong></label>
                        <div className="pt-2">
                            <label className="mr-4">
                                <input
                                    type="radio"
                                    name="tipoExecucao"
                                    checked={Number(tipoExecucao) === 1}
                                    onChange={() => setTipoExecucao(1)}
                                    className="mr-1"
                                />
                                Ativar
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="tipoExecucao"
                                    checked={Number(tipoExecucao) === 0}
                                    onChange={() => setTipoExecucao(0)}
                                    className="mr-1"
                                />
                                Desativar
                            </label>
                        </div>
                    </div>

                    {tipoItemNum === 1 && Number(tipoExecucao) === 1 &&
                        <div className="col-12 col-lg-6 px-2 mt-4">
                            <label className="pl-2"><strong>Ordenação no carrossel:</strong></label>
                            <input
                                type="number"
                                className="form-control"
                                value={ordenacao}
                                onChange={(e) => setOrdenacao(e.target.value)}
                            />
                        </div>
                    }

                    {(tipoItemNum === 2 || tipoItemNum === 3) &&
                        <div className="col-12 mt-4">
                            <label className="pl-2"><strong>Imagem (opcional):</strong></label>
                            <br />
                            {imageUrl && arquivoSalvo &&
                                <p className="pl-2" style={{ fontSize: '14px' }}>Imagem atual: <a href={imageUrl} target="_blank" rel="noopener noreferrer">{imageUrl}</a></p>
                            }
                            <input type="file" accept=".jpg,.jpeg,.png" onChange={onSelectFileImage} />
                            <br />
                            {temArquivo &&
                                <>
                                    <label className="pl-2 pt-2"><strong>Nome do arquivo:</strong></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        value={imageName || ''}
                                        onChange={(e) => setImageName(e.target.value)}
                                    />
                                    <br />
                                    {loadingSalvarImg ?
                                        <div className="spinner-border text-success" role="status" />
                                        :
                                        <div>
                                            <button onClick={salvarImg} disabled={!imageName} className="btn btn-outline-success">salvar imagem</button>
                                            {mensagemSalvar && !arquivoSalvo && <small className="text-danger ml-3">Necessário salvar a imagem antes de continuar</small>}
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    }

                    {erro && <div className="col-12 mt-3"><small className="text-danger">{erro}</small></div>}

                    <div className="col-12 text-right py-3">
                        {salvando ?
                            <div className="spinner-border text-success" role="status" />
                            :
                            <button className="btn btn-outline-success" disabled={!podeSalvar()} onClick={salvar}>
                                {itemEdicao ? "Salvar agendamento" : "Incluir agendamento"}
                            </button>
                        }
                    </div>
                </div>
            </div>

            <Modal isOpen={modalSuccess} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    CILE - Fila Betalabs
                </ModalHeader>
                <ModalBody>
                    Agendamento {itemEdicao ? "atualizado" : "incluído"} com sucesso!
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={toggleModal}>ok</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default withRouter(CileBetalabsFilaDetails);
